import { cn } from '#/lib/utils'
import { ATTENTION_CLASS, type AttentionState } from '#/lib/attention'
import { m } from '#/paraglide/messages'

export const attentionLabel = (s: AttentionState) =>
  s === 'blocked' ? m.inbox_state_blocked() : s === 'working' ? m.inbox_state_working() : s === 'done' ? m.inbox_state_done() : s === 'idle' ? m.inbox_state_idle() : m.inbox_state_unknown()

/** The one status pill every surface uses (Inspirasi F1): five states, plain words, no accent colour. */
export function AttentionPill({ state, className, dot = true }: { state: AttentionState; className?: string; dot?: boolean }) {
  return (
    <span className={cn('inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-px text-[11px] font-medium', ATTENTION_CLASS[state], className)} data-state={state} data-testid="attention-pill">
      {dot ? <span className={cn('size-1.5 rounded-full bg-current', state === 'working' && 'animate-pulse')} aria-hidden /> : null}
      {attentionLabel(state)}
    </span>
  )
}
